<template>
    <modal v-model="openModal" size="lg" :title="trans('general.page.planners.activity')">
        <div class="row g-2">
            <div :class="[addingNewSetting ? 'col-12' : 'col-md-6 mb-3']">
                <SettingSelect
                    :label="trans('general.page.planners.plan_form.activity')"
                    type="activity"
                    ref="settingSelect"
                    v-model="title"
                    :allow-new="allowNew"
                    :error="errorFields.title"
                    v-on:adding-new="addingNewSetting = $event"
                    v-on:reset-error="errorFields.title = null"/>
            </div>
            <div v-if="!addingNewSetting" class="col-md-6 mb-2">
                <basic-date-picker
                    mode="dateTime"
                    :label="trans('general.page.planners.plan_form.start')"
                    :required="true"
                    v-model="model.start"
                    :valid-hours="{ min: 6, max: 19 }"
                    :locale="lang"
                    :select-attribute="selectAttribute"
                    :minute-increment="15"
                    :masks="masks"
                    :error="errorFields.start"
                    v-on:reset-error="errorFields.start = null"/>
            </div>
            <div v-if="!addingNewSetting" class="col-12 mb-3">
                <div class="form-floating">
                    <textarea v-model="model.description" class="form-control" name="description" id="description" cols="30" rows="10"></textarea>
                    <label for="description"> {{trans('general.page.planners.plan_form.description') }}</label>
                </div>
            </div>
        </div>
        <plan-form-footer v-if="!addingNewSetting" :model="model" v-on:submit="submit" v-on="$listeners"/>
    </modal>
</template>

<script>
import Modal from "../../../theme/organisms/Modal";
import SettingSelect from "../../../theme/atoms/SettingSelect";
import EventFormHead from "../atoms/EventFormHead";
import FormErrorAlerts from "../../../theme/molecules/FormErrorAlerts"
import PlanForm from "./PlanForm";
import PlanFormFooter, {SUBMIT_PLAN_WAITER} from "./PlanFormFooter";
import {handleErrors} from "../../../services/ErrorHandler";
import BasicDatePicker from "../../../theme/atoms/BasicDatePicker.vue";
import KSelect from "../../../theme/molecules/KSelect.vue";

export default {
    name: "ActivityForm",
    extends: PlanForm,
    components: {
        BasicDatePicker,
        Modal,
        SettingSelect,
        EventFormHead,
        FormErrorAlerts,
        PlanFormFooter,
        KSelect,
    },
    data() {
        return {
            addingNewSetting: false,
        }
    },
    methods: {
        submit() {
            this.model.type = this.eventType;
            this.model.start = this.formatDateForDB(this.model.start);
            let url = !this.model.id ? `/plans/new` : `/plans/${this.model.id}`;

            axios.post(url, this.model)
                .then(response => {
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                    this.$emit('event-saved', response.data.data)
                })
                .catch(error => {
                    this.$wait.end(SUBMIT_PLAN_WAITER);
                    handleErrors(error, this, this.errorFields);
                })
        },
    }
}
</script>
